module.exports = __webpack_public_path__ + "assets/img/InvitationRegisterBg.3afdba63.png";